//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
import DOMPurify from 'dompurify';
import Multiselect from 'vue-multiselect'
import {
  configureRepeat,
  removeRepeat,
  addLabel,
  updateLabels,
} from '../db-utils.js'
import {
  calcItemColor,
  isSubtask,
} from '../utils.js';
  import {formatDateChip} from '../time-utils.js';
import { getReversedAncestors } from '../ordered-relation';


export default {
  props: [
    'task',
    'parentcolor',
  ],
  data() {
    return {
      editMode: false,
      members: this.task.couch.collaborators
    };
  },
  components: {
    Multiselect,
  },
  computed: {
    creationDate() {
      const ts = this.task._id.split(':')[1].split('.')[0];
      const date = moment(parseInt(ts, 36));
      return `${this.$gettext('Created')}: ${date.format('Y-MM-DD')}`;
    },
    showMembers() {
      return this.task.couch.collaborators.length > 1
    },
    ownerInfo() {
      return this.$gettext('Owner') + ': ' + this.task.couch.displayName;
    },
    showDateChip() {
      return !!this.task.plannedFor;
    },
    itemColor() {
      return calcItemColor(this.task, this.$reactiveCache);
    },
    dateChipText() {
      const pf = this.task.plannedFor;
      return (pf.parentClass === 'list' && this.$reactiveCache.docs[pf.parentKey])
        ? this.$reactiveCache.docs[pf.parentKey].name
        : formatDateChip(pf, this.$gettext);
    },
    eventDescription() {
      return DOMPurify.sanitize(this.task.event.description);
    },
    labels() {
      if (this.task.labels) {
        return this.task.labels
          .map(id => this.$reactiveCache.docs[id])
          .filter(doc => !!doc);
      } else {
        return [];
      }
    },
    parentMembers() {
      const ancestors = getReversedAncestors(this.task.cache, this.task)
        .map(rel => rel.subtaskOf)
        .map(pptr => pptr.parentKey)
        .map(id => this.$reactiveCache.docs[id])
      const combinedAssignees = [].concat.apply(
        [],
        ancestors.filter(item => !!item.assignees).map(item => item.assignees)
      );
      return combinedAssignees;
    },
  },
  methods: {
    isSubtask,
    allowRepeatUnit(unit) {
      if (!this.task.plannedFor) return false;
      const timeValues = {
        day: 1,
        week: 7,
        month: 30,
        year: 365,
        backlog: Infinity,
      }
      return timeValues[unit] >= timeValues[this.task.plannedFor.parentClass];
    },
    saveTask() {
      // FIXME: this triggers unnecessarily right away when task is opened
      this.task.save()
    },
    repeatOptionText(unit) {
      switch (unit) {
        case 'day':
          return this.$gettext('day(s)');
        case 'week':
          return this.$gettext('week(s)');
        case 'month':
          return this.$gettext('month(s)');
        case 'year':
          return this.$gettext('year(s)');
      }
    },
    clearRepeat() {
      removeRepeat(this.task);
    },
    updateRepeat(attrName, attrValue) {
      configureRepeat(this.task, attrName, attrValue)
    },
    addNewLabel(newLabel) {
      addLabel(this.task, newLabel)
      const updatedSettings = this.$settings.clone()
      // Initialize if missing.
      updatedSettings.labels = updatedSettings.labels || [];
      updatedSettings.labels.push(newLabel);
      updatedSettings.save()
    },
    changeLabels(newLabels) {
      updateLabels(this.task, newLabels)
    },
    getInitials(name) {
      const teamSettings = this.$reactiveCache.metadata[this.task.couch.name]?.settings
      if (teamSettings?.initials && teamSettings?.initials[name]) {
        return teamSettings?.initials[name]
      }
      // Include digits, as some usernames may differ only by number
      const initials = name.split(/[^a-z0-9]/i).map(word => word[0]).join('')
      return initials.toUpperCase().substring(0, 2);
    },
  },
}
